import type { GameId } from '../platform/types';

interface GameArtworkProps {
  game: GameId;
  compact?: boolean;
}

const Art = ({ game }: { game: GameId }) => {
  if (game === 'mossfire') {
    return <><i className="art-moon" /><i className="art-flame" /><i className="art-creature c-one" /><i className="art-creature c-two" /><i className="art-grass" /></>;
  }
  if (game === 'drift-courier') {
    return <><i className="art-sun" /><i className="art-road" /><i className="art-car"><b /><b /><b /></i><i className="art-building b-one" /><i className="art-building b-two" /></>;
  }
  if (game === 'dinky-diner') {
    return <><i className="art-checker" /><i className="art-plate"><b /></i><i className="art-chef"><b /></i><i className="art-steam s-one" /><i className="art-steam s-two" /></>;
  }
  if (game === 'hexhold') {
    return <><i className="art-hex h-one" /><i className="art-hex h-two" /><i className="art-hex h-three" /><i className="art-tower"><b /></i><i className="art-arrow" /></>;
  }
  if (game === 'twenty-one-terrors') {
    return <><i className="art-card card-one">A</i><i className="art-card card-two">K</i><i className="art-eye"><b /></i><i className="art-chip chip-one" /><i className="art-chip chip-two" /></>;
  }
  if (game === 'orbital-salvage') {
    return <><i className="art-orbit" /><i className="art-planet"><b /></i><i className="art-ship" /><i className="art-star st-one" /><i className="art-star st-two" /><i className="art-star st-three" /></>;
  }
  return <><i className="art-platform p-one" /><i className="art-platform p-two" /><i className="art-runner"><b /></i><i className="art-echo e-one"><b /></i><i className="art-echo e-two"><b /></i><i className="art-door" /></>;
};

export default function GameArtwork({ game, compact = false }: GameArtworkProps) {
  return (
    <div className={`game-art game-art--${game} ${compact ? 'game-art--compact' : ''}`} aria-hidden="true">
      <div className="art-noise" />
      <Art game={game} />
      <span className="art-registration r-one" />
      <span className="art-registration r-two" />
    </div>
  );
}
